import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ccdaf0d0")

_pushScopeId("data-v-ccdaf0d0")
const _hoisted_1 = { class: "feedback" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TabbedPage = _resolveComponent("TabbedPage")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_TabbedPage, {
      tabs: _ctx.tabs,
      pages: _ctx.pages
    }, null, 8, ["tabs", "pages"])
  ]))
})